import { ButtonHTMLAttributes } from 'react';
import css from './Switch.module.scss';

type SwitchProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  switched: boolean;
  onChange: () => void;
  alt?: string;
  isCheckoutRedesign?: boolean;
};

const Switch = ({ switched, onChange, alt = '', isCheckoutRedesign = false, ...props }: SwitchProps) => {
  return isCheckoutRedesign ? (
    <button
      onClick={onChange}
      aria-checked={switched}
      role="switch"
      type="button"
      className={`${css.button} 
        ${switched ? 'bg-bg_brand border-bg_brand' : 'bg-bg_secondary_hover border-border_disabled'} 
        relative inline-flex w-[30px] items-center rounded-full border-[3px] outline-none`}
      {...props}>
      <span className="sr-only">{alt}</span>
      <span
        className={`${switched ? 'translate-x-[12px]' : 'translate-x-0'} 
          inline-block h-3 w-3 transform rounded-full bg-white transition`}
      />
    </button>
  ) : (
    <button
      onClick={onChange}
      aria-checked={switched}
      role="switch"
      type="button"
      className={`${css.button} ${
        switched ? 'bg-black-800 border-black-900' : 'bg-black-500 border-black-600'
      } relative inline-flex w-[52px] items-center rounded-full border-[1.5px] outline-none`}
      {...props}>
      <span className="sr-only">{alt}</span>
      <span
        className={`${
          switched ? 'translate-x-[21px]' : 'translate-x-0'
        } inline-block h-7 w-7 transform rounded-full bg-white transition`}
      />
    </button>
  );
};

export default Switch;
